// extracted by mini-css-extract-plugin
module.exports = {"mark":"antd-pro-components-highlighter-custom-style-mark"};